// extracted by mini-css-extract-plugin
module.exports = {"pageBox":"style_pageBox__R4JwI","listArticleNav":"style_listArticleNav__F6RTp","disabled":"style_disabled__JgPkh","pageCount":"style_pageCount__e8C9m"};